export class MisReportConfig {
    enableReporting: boolean;
    enableReportingFromDate: string;
    misReportConfigChanged: boolean;
}
